/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable valid-typeof */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable eqeqeq */
/* eslint-disable no-lonely-if */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container, Form, Image } from 'react-bootstrap'
import Select from 'react-select'
import { withRouter } from 'react-router-dom'
// eslint-disable-next-line
import './form.scss'
import ReCAPTCHA from 'react-google-recaptcha'
import BaseScreen from '../../base'
import globalConstant from '../../../store/constant/global'
import auth from '../../../store/constant/auth'
// import { danaTalangan, danaTalanganNext, getKodeProduk } from '../../../api/action/transaction'
import AlertDialog from '../../dialog/alert'
// import DateTime from '../../../helper/datetime'
import checkAccess from '../../../helper/access'
import roleAccess from '../../../store/constant/roleAccess'
import AccessDenied from '../PermissionShow'
import translate from '../../../helper/translate'
import { placeholderResource } from '../../../helper/translatePage/languageResource'
// import getCsrf from '../../../api/action/getCsrf'
// import logout from '../../../api/action/logout'
import OtpModal from '../../tools/otp_modal'
import logout from '../../../api/action/logout'
import getCsrf from '../../../api/action/getCsrf'
import createOtp from '../../../api/action/createOtp'
import { getWhitelistIpLoginByID, postWhitelistIpLogin } from '../../../api/action/whitelistIpLogin'
import icons from '../../../helper/icons'
import iconName from '../../../helper/constant/iconName'

class FormIpWhitelist extends BaseScreen {
  constructor(props) {
    super(props, ['page--dana'])
    const { id } = props.match.params
    const { path } = props.match

    const [action, type] = path.split('/').filter(Boolean)

    this.state = {
      alertError: '',
      loading: false,
      modal: false,
      dataInfo: null,
      // date: DateTime.parse(new Date(), DateTime.FMT_DATE_YMD).toDate(),
      // showPass: false,
      action: action,
      id_detail: id,
      type: type,
      recaptcha: '',
      selectedKey: null,
      keyList: [
        { value: true, label: 'Iya' },
        { value: false, label: 'Tidak' },
      ],
      ipAddres: '',
      resetOtp: false,
    }

    this.captchaRef = React.createRef().current
  }

  onChangeRecaptcha = (value) => {
    this.setState({ recaptcha: value })
  }

  componentDidMount() {
    if (this.state.type == 'edit') {
      this.getDetail(this.state.id_detail)
    }
    // this.getProduk()
  }

  modalClosed = () => {
    this.setState({ modal: false })
  }

  modalShowed = () => {
    this.setState({ modal: true })
  }

  selectHandle = (e) => {
    this.setState({ selectedKey: e })
  }

  showError = (alertError) => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ alertError })
  }

  closeError = () => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ alertError: '' })
  }

  getDetail = async (id) => {
    this.setState({ loading: true })
    const { dispatch } = this.props
    try {
      const response = await dispatch(getWhitelistIpLoginByID(id))
      if (response.isOK()) {
        const { data } = response.data
        this.setState({
          loading: false,
          ipAddres: data.ip_address,
          selectedKey: { label: data.is_active ? 'Iya' : 'Tidak', value: data.is_active },
        })
      } else {
        this.setState({ loading: false })
        this.setState({ alertError: response.getRD() })
      }
    } catch (error) {
      this.setState({ loading: false })
      this.setState({ alertError: 'Something Goes Wrong, Please Contact Us in teletrans.id' })
    }
  }

  generateOTP = async (id) => {
    if (this.state.recaptcha === '') {
      this.showError('Please Fill Captcha')
    } else {
      const res = await this.props.dispatch(createOtp(this.state.recaptcha))

      if (res.data.rc == '00') {
        this.setState({
          emailOtp: res.data.data.email,
          idOTP: res.data.data.idOtp,
          showOtpAlert: false,
          showModal: false,
          recaptcha: '',
        })
        this.generatePINOtp(id)
      } else {
        this.showError(res.data.rd)
      }
    }
  }

  generatePINOtp = (id) => {
    this.showedOtpModal()
    this.setState({
      otpSuccessFunc: (otpCode, recaptcha) => this.whitelistIpLogin(otpCode, recaptcha, id),
    })
  }

  whitelistIpLogin = async (otpCode, recaptcha, id) => {
    const { ipAddres, selectedKey, type } = this.state
    const response = await this.props.dispatch(getCsrf())
    if (response.isOK()) {
      const res = await this.props.dispatch(
        postWhitelistIpLogin(
          otpCode,
          this.state.idOTP,
          recaptcha,
          type,
          ipAddres,
          selectedKey.value,
          id
        )
      )

      if (res.data.rc != '00') {
        this.showError(res.data.rd)
      } else {
        this.hideOtpModal()
        this.showError(res.data.rd)
        this.resetForm()
      }
    } else {
      this.props.dispatch(logout())
    }
  }

  onSubmitDelete = async (id) => {
    this.setState({ type: 'delete' })
    const { dispatch } = this.props
    const { recaptcha } = this.state
    const response = await dispatch(getCsrf())
    if (!recaptcha) {
      dispatch({ type: globalConstant.IS_LOADING, payload: false })
      this.showError('Please fill recatpcha')
    } else {
      if (response.isOK()) {
        this.generateOTP(id)
      } else {
        dispatch(logout())
      }
    }
  }

  onSubmit = async (id) => {
    this.captchaRef.reset()
    // eslint-disable-next-line no-unused-vars
    const { dispatch, appUserData, history } = this.props
    const { recaptcha, selectedKey, ipAddres } = this.state

    if (ipAddres === '') {
      dispatch({ type: globalConstant.IS_LOADING, payload: false })
      this.showError('Anda belum memasukkan Ip Address ')
    } else if (selectedKey === null) {
      dispatch({ type: globalConstant.IS_LOADING, payload: false })
      this.showError('Anda belum memilih apakah Aktif')
    } else if (!recaptcha) {
      dispatch({ type: globalConstant.IS_LOADING, payload: false })
      this.showError('Please fill recatpcha')
    } else {
      const response = await dispatch(getCsrf())
      if (response.isOK()) {
        this.generateOTP(id)
      } else {
        dispatch(logout())
      }
    }
  }

  hideOtpModal = () => {
    this.setState({ showOtpModal: false, showOtpAlert: false })
    this.resetOtpCode()
  }

  resetOtpCode = () => {
    this.setState({ resetOtp: true })
  }

  resetForm = () => {
    this.setState({ selectedKey: null, ipAddres: '' })
  }

  showedOtpModal = () => {
    this.setState({ showOtpModal: true })
  }

  createAccess = () => {
    return checkAccess(this.props.appUserAccess, 'data_whitelist_ip_login', 'ADD')
  }

  notResetOtpCode = () => {
    this.setState({ resetOtp: false })
  }

  formHandleChange = (e) => {
    const { name, value } = e.target

    this.setState({ [name]: value })
  }

  renderForm() {
    return (
      <Container fluid className="p-3 container-transfer container-content mt-4">
        {/* <div className="fontSize-20 mb-5">Tambah Dana Talangan</div> */}
        {!this.createAccess() ? (
          <AccessDenied />
        ) : (
          <>
            <Form.Group>
              <Form.Label className="fontSize-16-SemiBold">IP Address</Form.Label>
              <Form.Control
                placeholder="Masukkan IP Address"
                value={this.state.ipAddres}
                onChange={this.formHandleChange}
                name="ipAddres"
                className="fontSize-16 custom-input"
              />
            </Form.Group>
            <Form.Group className="form-left">
              <Form.Label>Apakah Aktif?</Form.Label>
              <Select
                value={this.state.selectedKey}
                options={this.state.keyList}
                onChange={this.selectHandle}
                placeholder={translate('select', this.props.language, placeholderResource)}
                className="custom-input fontSize-16"
              />
            </Form.Group>
            <ReCAPTCHA
              ref={(ref) => {
                this.captchaRef = ref
              }}
              className="mt-3"
              sitekey={process.env.REACT_APP_GRECAPTCHA_KEY}
              onChange={(e) => {
                this.onChangeRecaptcha(e, 2)
              }}
            />
            <div className="container-split-form">
              <Form.Group>
                <button
                  type="button"
                  className={`btn btn-primary btn-block color-white btn-custom fontSize-17 ${
                    this.props.appIsLoading ? 'disabled' : ''
                  }`}
                  onClick={() =>
                    this.onSubmit(this.state.type == 'edit' ? this.state.id_detail : null)
                  }
                >
                  {this.state.type == 'add' ? 'Tambah' : 'Edit'}
                </button>
              </Form.Group>
              {this.state.type == 'edit' ? (
                <Form.Group>
                  <button
                    type="button"
                    className={`btn btn-primary btn-block color-white btn-custom fontSize-17 ${
                      this.props.appIsLoading ? 'disabled' : ''
                    }`}
                    onClick={() => this.onSubmitDelete(this.state.id_detail)}
                  >
                    Hapus
                  </button>
                </Form.Group>
              ) : (
                <></>
              )}
            </div>
          </>
        )}
      </Container>
    )
  }

  backHandle = () => {
    this.props.history.push('/data/whitelist_ip_login')
  }

  render() {
    const { action } = this.state
    return (
      <>
        <div>
          <button
            type="button"
            className="btn btn-outline-primary back-button"
            onClick={this.backHandle}
          >
            <Image src={icons(iconName.backButton)} className="" />
          </button>
        </div>
        {action === 'form' && this.renderForm()}
        {/* {action === 'success' && this.modalSuccess(this.state.dataSuccessTopup)}
        {action === 'gagal' && this.modalInfo(this.state.dataInfo)} */}

        <AlertDialog
          show={!!this.state.alertError}
          onHide={this.closeError}
          onConfirm={this.closeError}
          type="warning"
          messageTitle={this.state.alertError}
        />
        <OtpModal
          show={this.state.showOtpModal}
          onHide={this.hideOtpModal}
          parentFunc={this.state.otpSuccessFunc}
          errMsg={this.showError}
          email={this.state.emailOtp}
          idOtp={this.state.idOTP}
          btnDisable={this.props.appIsLoading}
          resetOtp={this.state.resetOtp}
          resetOtpFunc={this.notResetOtpCode}
          type={
            this.state.otp_type == 'generate_new_credential' ||
            this.state.otp_type == 'generate_pin' ||
            this.state.otp_type == 'activate_signature'
          }
        />
      </>
    )
  }
}

FormIpWhitelist.defaultProps = {
  appIsLoading: false,
}

FormIpWhitelist.propTypes = {
  appIsLoading: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
}

export default withRouter(
  connect(
    (state) => ({
      appIsLoading: state.Global[globalConstant.IS_LOADING],
      language: state.Global[globalConstant.LANGUAGE],
      appUserData: state.Auth[auth.USER_DATA],
      token: state.Auth[auth.TOKEN],
      appUserAccess: state.RoleAccess[roleAccess.ACCESS],
      appAgentUser: state.Auth[auth.AGENT_USER],
    }),
    (dispatch) => ({ dispatch })
  )(FormIpWhitelist)
)
